import videojs from 'video.js';

const DEFAULTS = {
  events: []
};

/**
 * The events emitter for stat
 *
 * @param {Object} player   Main Player
 * @param {Object=} options Object of option names and values
 * @extends EventTargetm
 */

class MsgEmitter extends videojs.EventTarget {
  constructor(player, options) {
    super();
    this.options = Object.assign({}, DEFAULTS, options);

    this.player = player;
    this.events = new Set(this.options.events);
    this._addEvents();
  }

  _addEvents() {    
    this._addPlayerEvents();
    this._addCustomEvents();
  }

  _addPlayerEvents() {
    this.events.forEach((ev) => {
      this.player.on(ev,  () => {
        this.trigger(ev);
      });
    });
  }

  _addCustomEvents() {
    // empty. Example:
    //this.player.on('error', () => {
    //  if (!this.utils.isAdPlaying()) this.trigger('contentError');
    //});
  }
}

export default MsgEmitter;
